import * as React from "react";

import "./preview-cc-view.scss";

import {BlockWindowUnload}    from "@Common/react/block-window-unload";
import {cs}                   from "@Common/react/chain-services";
import {consumeContext,
        provideContext}       from "@Common/react/context";
import {joinJsx}              from "@Common/react/join-jsx";
import {TimeoutAction}        from "@Common/react/timeout-action";
import {UseState}             from "@Common/react/use-state";
import {Button}               from "@Common/tools/cc-integration/ui/button/button";
import {PhotoDashboard}       from "@Common/ui-components/photo-dashboard/photo-dashboard";
import {RefreshTemplateModal} from "@Common/ui-components/refresh-template-modal/refresh-template-modal";
import {Responsive}           from "@Common/ui-components/responsive";

import {Instruction}      from "../../../../customize/steps/common/instruction/instruction";
import {ExhibitXpresso}   from "../../../../customize/steps/customize/cc-view/exhibit-xpresso/exhibit-xpresso";
import {SaveAlerts}       from "../../../../customize/steps/customize/common/SaveAlerts";
import {SaveModal}        from "../../../../customize/steps/customize/common/SaveModal";
import {Layout}           from "../../../../layout/layout";

export const PreviewCcView = (
    {
        editingStateId,
        mockData,
        preview,
        previewState,
        previewHighResUrls,
        template,
        templateModal,
        templateIds,
        userCreatedCcConfig,
        advEditMode,
        update
    }
) => cs(
    consumeContext("ccApis"),
    consumeContext("company"),
    consumeContext("userLevels"),
    ["previewState", (_, next) => UseState({ initValue: previewState,
        next,
    })],
    ["previewHighResUrls", (_, next) => UseState({
        initValue: previewHighResUrls.value,
        next,
    })],
    ["renderEmptyLayout", (_, next) => next(({messages, loading, error}) => (
        <Layout className="customize-layout-95r">
            <div className="product-options-step-6rz">
                <div {...{
                    className: "center",
                    ...error ? {
                        "xd-qa-type": "label",
                        "xd-qa-name": "error",
                    } : loading && {
                        "xd-qa-type": "label",
                        "xd-qa-name": "Loading",
                    },
                }}>
                    {joinJsx(messages, () => <br/>)}
                </div>
            </div>
        </Layout>
    ))],
    ["templateOptions", ({renderEmptyLayout}, next) => cs(
        consumeContext("templateOptionsCache"),
        ["templateOptions", ({templateOptionsCache}, next) => templateOptionsCache.load({
            key: {'front': templateIds[0], 'back': templateIds[0]},
            next,
        })],
        ({templateOptions}) => templateOptions.loading ? (
            renderEmptyLayout({
                messages: ["Loading Template Options..."],
                loading: true,
            })
        ) : (
            (!templateOptions.value) ? (
                renderEmptyLayout({
                    messages: [
                        "There was an error loading the template options.",
                        "Please go back and try again.",
                        "If the issue persists please contact us.",
                    ],
                })
            ) : (
                next({
                    ...templateOptions.value,
                    'options': Object.keys(templateOptions.value?.options)?.filter(o => o !== 'enable_cc_adv_mode')
                })
            )
        ),
    )],
    ({templateOptions}, next) => provideContext({templateOptions}, next),

    ["exhibit", ({}, next) => (
        ExhibitXpresso({
            ccValues: { template, templateIds, userCreatedStateId: editingStateId, userCreatedCcConfig },
            componentId: null,
            templateIds,
            inputData: null,
            item: {},
            listing: {},
            advEditMode,
            mockData,
            templateVariations: null,
            next,
        })
    )],

    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],

    ["saveConfirmedAlert", (_, next) => UseState({next})],
    ({saveConfirmedAlert, exhibit}, next) => SaveModal({
        changeAlertMessage: (msg) => saveConfirmedAlert.onChange(msg),
        onSave: exhibit.save,
        disabled: !exhibit.changed,
        next,
    }),
    ["refreshTemplateModal", ({ccApis, exhibit}, next) => RefreshTemplateModal({
        onRefresh: async () => {
            exhibit.clearChanged();
            await ccApis.deleteState(exhibit.ccStateId)
            window.location.reload();
        },
        next,
    })],
    ["importModal", ({}, next) => PhotoDashboard({next})],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            mobile: 500,
        },
        next,
    }}/>],
    ["updating", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })],
    ({ccApis, exhibit, saveConfirmedAlert, refreshTemplateModal, saveButtons, isInternalUser, previewState, previewHighResUrls, updating}) => {
        var updateObj = {};
        if( exhibit.ccStateId != undefined && exhibit.ccStateId !== previewState.value ) {
            previewState.onChange( exhibit.ccStateId );
            updateObj = {previewState: exhibit.ccStateId};
        }
        if( (!previewHighResUrls.value || Object.keys(previewHighResUrls.value).length === 0) && exhibit.highResProducts?.['jpg'] ) {
            previewHighResUrls.onChange( exhibit.highResProducts?.['jpg'] );
            updateObj = {...updateObj, previewHighResUrls: exhibit.highResProducts?.['jpg']};
        }
        if( Object.keys(updateObj).length > 0 ) {
            update(updateObj);
        }
        return <div className="preview-cc-view-87j" style={{position: "relative"}}>
            {exhibit.changed && BlockWindowUnload({})}

            {!exhibit.initialized && (
                <div className="container">
                    <div className="overlay" />
                    <img className="loadingImage" {...{
                        src: exhibit.proofImages?.[0] ?? "assets/SPINNER.svg",
                        alt: "spinner"
                    }}/>

                    {exhibit.proofImages?.[0] && !advEditMode ? (
                        <button
                            className="retry"
                            onClick={()=>window.location.reload()}
                            xd-qa-type="button"
                            xd-qa-name="Retry"
                        >Retry</button>
                    ) : exhibit.proofImages?.[0] == "assets/SPINNER_ERROR_STATE_FAILED.svg" && (
                        <button
                            className="retry"
                            onClick={()=>refreshTemplateModal.show()}
                            xd-qa-type="button"
                            xd-qa-name="Refresh Template"
                        >
                            Refresh Template
                        </button>
                    )}
                </div>
            )}

            {saveConfirmedAlert.value && exhibit.ccHost && <>
                {SaveAlerts({
                    message: saveConfirmedAlert.value,
                    onClose: () => saveConfirmedAlert.onChange(null),
                })}

                {saveConfirmedAlert.value.success && TimeoutAction({
                    delay: 4000,
                    action: () => saveConfirmedAlert.onChange(null),
                })}
            </>}

            <div className="main">
                <div className="controls">
                    {exhibit.controls}
                </div>
                {advEditMode && exhibit.editForm}

                <div className="line2">

                    <div className="left">
                        <div className="editor" style={ advEditMode ? {marginRight: "0px"} : {} }>
                            <div className={(exhibit.fullScreen) ? "editor-items-fullscreen" : "editor-items-standard"}>
                                <div className="content">
                                    {exhibit.render()}
                                </div>
                                <div className="download-reset-buttons">
                                    <div>
                                        <div className="buttonContainer">
                                            <Button
                                                buttonText="Return to Editing"
                                                xdQaName="Return to Editing"
                                                downloadProgressPercent={updating.value.downloadPercent}
                                                onClick={async () => {
                                                    if( previewState.value ) {
                                                        await ccApis.deleteState(previewState.value);
                                                    }
                                                    // remove download percent after another second to ensure that 100% status is displayed to the user
                                                    setTimeout(() => updating.onChange({...updating.value, downloadPercent: 0}), 1000);

                                                    preview.onChange(!preview.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {exhibit.initialized && (<>
                                        <div>
                                            {exhibit.watermarkDownload}
                                            {isInternalUser && exhibit.prodFileDownload}
                                            <div className="buttonContainer">
                                                <Button
                                                    buttonText="Confirm Changes"
                                                    xdQaName="Confirm Changes"
                                                    onClick={ async () => {
                                                        templateModal.show();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            {advEditMode && saveButtons}
                                        </div>
                                    </>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {!advEditMode && (
                        <div className="details">
                            {exhibit.initialized && <>
                                {Instruction({
                                    text: "Click on the template to make edits directly",
                                })}

                                {exhibit.editForm}

                                <div className="controls">
                                    <div className="buttons">
                                        {saveButtons}
                                    </div>
                                </div>
                            </>}
                        </div>
                    )}
                </div>
            </div>
        </div>
    }
);